/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEuro = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15 2a9.96 9.96 0 0 1 6.416 2.33l.251.217-1.333 1.49A7.963 7.963 0 0 0 15 4a8.002 8.002 0 0 0-7.42 5H17v2H7.062a8.081 8.081 0 0 0 0 2.001L17 13v2l-9.418.001A8.002 8.002 0 0 0 15.001 20a7.96 7.96 0 0 0 5.086-1.825l.247-.212 1.333 1.49A9.962 9.962 0 0 1 15 22c-4.477 0-8.267-2.942-9.541-6.999L3 15v-2l2.05.001a10.122 10.122 0 0 1 0-2.001H3V9h2.458C6.732 4.943 10.522 2 15 2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEuro as Euro };
